import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '../context/ToastContext';
import StoreService from '../services/storeService';

const useCheckoutLauncher = (storeId) => {
  const { t } = useTranslation();
  const { showError } = useToast();
  const [loading, setLoading] = useState(false);

  const startCheckout = useCallback(async () => {
    if (!storeId || loading) {
      return;
    }

    try {
      setLoading(true);

      const result = await StoreService.createCheckoutSession(storeId);
      const checkoutUrl = result?.url;

      if (!checkoutUrl) {
        throw new Error(t('stores.checkout.errors.invalidUrl'));
      }

      window.location.assign(checkoutUrl);
    } catch (err) {
      console.error('Error creating checkout session:', err);

      if (err?.response?.status === 403) {
        showError(t('stores.checkout.errors.ownerOnly'));
        return;
      }

      showError(err?.response?.data?.message || err?.message || t('stores.checkout.errors.open'));
    } finally {
      setLoading(false);
    }
  }, [loading, showError, storeId, t]);

  return {
    startCheckout,
    loading,
  };
};

export default useCheckoutLauncher;
